var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rtf-editor"},[(_vm.label)?_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(!_vm.readonly)?_c('div',{ref:"editor"}):_c('rtf-viewer',{attrs:{"json":_vm.json}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }